const userId = (state) => state.user.userData.id;

export default userId;
